import {
  StyledFooterMainDiv,
  StyledPrivacyLink,
  StyledTermsLink,
  StyledVersion,
} from "../../styles/components/Footer.styled";

export function Footer() {
  return (
    <StyledFooterMainDiv>
      <StyledPrivacyLink to="/Privacy">Privacy Policy</StyledPrivacyLink>
      <StyledTermsLink to="/Terms">Terms and Conditions</StyledTermsLink>
      <StyledVersion>Version 1.0.6</StyledVersion>
    </StyledFooterMainDiv>
  );
}
